import { component } from 'picoapp'
import $ from 'quantdom'

export default component((node) => {
  var debounceTimeout

  $(window).on('load', (e) => {
    $(node).find('[data-scroll-track]').el().scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    })
  })

  //scroll track scrolled
  $(node)
    .find('[data-scroll-track]')
    .on('scroll', (e) => {
      clearTimeout(debounceTimeout)
      debounceTimeout = setTimeout(function () {
        updateArrowsFromScrollPosition(e.target.scrollLeft)
      }, 100)
    })

  //arrow left clicked
  $(node)
    .find('.js-arrow-left')
    .on('click', () => {
      scrollByClick('left')
    })

  //arrow right clicked
  $(node)
    .find('.js-arrow-right')
    .on('click', () => {
      scrollByClick('right')
    })

  //dot clicked
  $(node)
    .find('[data-scroll-dot]')
    .on('click', (e) => {
      scrollToPosition(parseInt($(e.target).attr('data-scroll-dot-index')))
    })

  //Helper functions
  const getPosition = (el) => {
    return parseInt($(el).attr('data-scroll-position'))
  }

  const setPosition = (el, position) => {
    $(el).attr('data-scroll-position', position)
    updateDots(position)
  }

  const updateArrowsFromScrollPosition = (pos) => {
    const scrollTrackEl = $(node).find('[data-scroll-track]').el()
    const scrollWidth = scrollTrackEl.scrollWidth
    const slideWidth = scrollTrackEl.offsetWidth
    const arrowLeft = $(node).find('.js-arrow-left').el()
    const arrowRight = $(node).find('.js-arrow-right').el()

    if (pos > 0 && arrowLeft) {
      arrowLeft.removeAttribute('disabled')
    } else if (arrowLeft) {
      arrowLeft.disabled = true
    }
    if (pos < scrollWidth - slideWidth && arrowRight) {
      arrowRight.removeAttribute('disabled')
    } else if (arrowRight) {
      arrowRight.disabled = true
    }

    setPosition(scrollTrackEl, Math.round(pos / slideWidth) + 1)
  }

  const scrollByClick = (direction) => {
    const scrollTrackEl = $(node).find('[data-scroll-track]').el()
    const slideWidth = scrollTrackEl.offsetWidth
    const position = getPosition($('[data-scroll-track]').el())
    const scrollToIndex = direction == 'right' ? position + 1 : position - 1
    const scrollToPx = scrollToIndex == 1 ? 0 : scrollToIndex * slideWidth - slideWidth / 2 - 1

    setPosition(scrollTrackEl, scrollToIndex)

    //Scroll to
    scrollTrackEl.scrollLeft = scrollToPx
  }

  const scrollToPosition = (position) => {
    const scrollTrackEl = $(node).find('[data-scroll-track]').el()
    const colGap = parseInt(getComputedStyle(scrollTrackEl).columnGap)
    const slideWidth = scrollTrackEl.clientWidth - (colGap ? colGap : 0)
    const scrollToPx = position == 1 ? 0 : position * slideWidth - slideWidth / 2 - 1

    //Scroll to
    scrollTrackEl.scrollLeft = scrollToPx
  }

  const updateDots = (selectedPos) => {
    for (let i = 0; i < $(node).find('[data-scroll-dot]').els.length; i++) {
      $($(node).find('[data-scroll-dot]').els[i]).attr('aria-current', false)
    }
    $(node).find(`[data-scroll-dot-index="${selectedPos}"]`).attr('aria-current', true)
  }
})
